<template>
  <div id="entryExitStation" class="entryExitStation" />
</template>

<script>
import {getHistoryStatistics} from '@/api/workBench'
export default {
  name: `EntryExitStation`,
  props: {
    axname: String
  },
  data () {
    return {
      year: 2024,
      dataSource: []
    }
  },
  mounted () {
    this.getHistory()
  },
  methods: {
    getHistory () {
      getHistoryStatistics({
        year: this.year
      }).then(res => {
        this.dataSource = res.data
        this.initStationDoor()
      })
    },
    initStationDoor () {
      const chartDom = document.getElementById('entryExitStation')
      let myChart = this.$echarts.getInstanceByDom(chartDom)
      if (myChart === undefined) {
        myChart = this.$echarts.init(chartDom, 'light')
      }
      this.$emit('getChart', myChart)
      const options = {
        tooltip: {},
        dataset: {
          dimensions: ['month', 'num'],
          source: this.dataSource
        },
        xAxis: {
          type: 'category',
          name: '月',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#ccc',
              width: 2
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            // interval: 0,
            // margin: 8,
            color: '#666'
            // fontSize: '0.10rem',
            // width: 105,
            // overflow: 'break'
          }
        },
        yAxis: {
          name: '次',
          axisTick: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#ccc',
              width: 2
            }
          },
          axisLabel: {
            color: '#666',
            // fontSize: '0.12rem'
            formatter: function (value, index) {
              function formatNum (strNum) {
                if (strNum.length <= 3) {
                  return strNum
                }
                if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
                  return strNum
                }
                var a = RegExp.$1
                var b = RegExp.$2
                var c = RegExp.$3
                var re = new RegExp()
                re.compile('(\\d)(\\d{3})(,|$)')
                while (re.test(b)) {
                  b = b.replace(re, '$1,$2$3')
                }
                return a + '' + b + '' + c
              }
              return Number.isInteger(value) ? formatNum(value) : ''
            }
          }
        },
        legend: {
          show: false,
          textStyle: {
            fontSize: '0.32rem'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '6%',
          top: '11.5%',
          containLabel: true
        },
        series: [
          {
            type: 'bar',
            name: '月活动数量',
            itemStyle: { color: '#00af84' },
            barWidth: 20
            // barGap: '30%', /* 多个并排柱子设置柱子之间的间距 */
            // barCategoryGap: '0%' /* 多个并排柱子设置柱子之间的间距 */
          }
        ]
      }
      myChart.setOption(options, true)

      myChart.on('magictypechanged', function (params) {
        const magicType = params.currentType
        if (magicType === 'line') {
          options.xAxis.boundaryGap = true
          options.series[0].type = magicType
          options.series[1].type = magicType
          myChart.setOption(options)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.entryExitStation {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>
